import { AccordionDetails, alpha, styled } from "@mui/material";

export const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  padding: `${theme.spacing(4)} ${theme.spacing(2)}`,
  borderTop: `1px solid ${theme.palette.divider}`,
  backgroundColor: alpha(theme.palette.primary.main, 0.12),
}));
